import { render, staticRenderFns } from "./editMessageInWise.vue?vue&type=template&id=504835a5&scoped=true&"
import script from "./editMessageInWise.vue?vue&type=script&lang=js&"
export * from "./editMessageInWise.vue?vue&type=script&lang=js&"
import style0 from "./editMessageInWise.vue?vue&type=style&index=0&id=504835a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504835a5",
  null
  
)

export default component.exports